import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faChartLine, faUsers, faStethoscope, faClock, faShieldAlt, faClipboardList, faPrescriptionBottle, faFileAlt, faIdCard } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import logo from '../img/medsolutions.jpg';

export default function LandingPage() {
    return (
        <div style={{ backgroundColor: '#f8f9fa' }}>
            {/* Hero Section */}
            <section style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                color: 'white', 
                padding: '100px 0' 
            }}>
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6}>
                            <h1 style={{ fontSize: '3.5rem', fontWeight: 'bold', marginBottom: '20px' }}>
                                MedSolutions
                            </h1>
                            <h2 style={{ fontSize: '1.5rem', marginBottom: '30px', opacity: 0.9 }}>
                                Sistema Completo de Gestão Médica
                            </h2>
                            <p style={{ fontSize: '1.2rem', marginBottom: '40px', opacity: 0.8 }}>
                                Gerencie sua clínica com eficiência. Agenda inteligente, controle de pacientes 
                                e relatórios em tempo real.
                            </p>
                            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                <Link to="/login">
                                    <Button size="lg" style={{ 
                                        backgroundColor: '#28a745', 
                                        border: 'none',
                                        padding: '12px 30px',
                                        fontSize: '1.1rem'
                                    }}>
                                        Acessar Sistema
                                    </Button>
                                </Link>
                                <Button 
                                    variant="outline-light" 
                                    size="lg"
                                    style={{ 
                                        padding: '12px 30px', 
                                        fontSize: '1.1rem',
                                        backgroundColor: '#25d366',
                                        borderColor: '#25d366'
                                    }}
                                    onClick={() => window.open('https://wa.me/5532988495161', '_blank')}
                                >
                                    <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '8px' }} />
                                    Contato WhatsApp
                                </Button>
                            </div>
                        </Col>
                        <Col lg={6} className="text-center">
                            <div style={{ 
                                backgroundColor: 'rgba(255,255,255,0.1)', 
                                borderRadius: '20px', 
                                padding: '40px',
                                backdropFilter: 'blur(10px)'
                            }}>
                                <img 
                                    src={logo} 
                                    alt="MedSolutions" 
                                    style={{ 
                                        maxWidth: '100%', 
                                        height: 'auto',
                                        borderRadius: '10px',
                                        opacity: 0.9
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Features Section */}
            <section style={{ padding: '80px 0' }}>
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#333' }}>
                                Funcionalidades Principais
                            </h2>
                            <p style={{ fontSize: '1.2rem', color: '#666' }}>
                                Tudo que você precisa para gerenciar sua clínica em um só lugar
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}
                            onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faCalendarAlt} 
                                        size="3x" 
                                        style={{ color: '#667eea', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Agenda Inteligente</h4>
                                    <p style={{ color: '#666' }}>
                                        Calendário interativo com visualização por médico, 
                                        encaixes automáticos e busca avançada de pacientes.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faUsers} 
                                        size="3x" 
                                        style={{ color: '#28a745', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Gestão de Pacientes</h4>
                                    <p style={{ color: '#666' }}>
                                        Cadastro completo, histórico de consultas, 
                                        controle de convênios e busca rápida por nome.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faChartLine} 
                                        size="3x" 
                                        style={{ color: '#ffc107', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Dashboards</h4>
                                    <p style={{ color: '#666' }}>
                                        Gráficos em tempo real de status de consultas, 
                                        procedimentos realizados e métricas da clínica.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faClipboardList} 
                                        size="3x" 
                                        style={{ color: '#dc3545', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Anamnese/Evolução</h4>
                                    <p style={{ color: '#666' }}>
                                        Linha do tempo completa de todas as consultas 
                                        com histórico detalhado do paciente.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faPrescriptionBottle} 
                                        size="3x" 
                                        style={{ color: '#28a745', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Receituário</h4>
                                    <p style={{ color: '#666' }}>
                                        Replique receituários de forma fácil e rápida 
                                        com modelos pré-configurados.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faFileAlt} 
                                        size="3x" 
                                        style={{ color: '#ffc107', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Pedidos de Exame</h4>
                                    <p style={{ color: '#666' }}>
                                        Utilize pedidos pré-cadastrados para 
                                        acelerar a emissão de solicitações.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faIdCard} 
                                        size="3x" 
                                        style={{ color: '#6f42c1', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Atestados</h4>
                                    <p style={{ color: '#666' }}>
                                        Crie seus atestados personalizados e 
                                        emita de forma rápida e profissional.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faShieldAlt} 
                                        size="3x" 
                                        style={{ color: '#17a2b8', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Segurança LGPD/CFM</h4>
                                    <p style={{ color: '#666' }}>
                                        Sistema em conformidade com LGPD e normas do CFM. 
                                        Backup automático e proteção de dados.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faWhatsapp} 
                                        size="3x" 
                                        style={{ color: '#25d366', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Confirmação WhatsApp</h4>
                                    <p style={{ color: '#666' }}>
                                        Envie confirmações de consulta e documentos 
                                        diretamente pelo WhatsApp do paciente.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section style={{ 
                backgroundColor: '#343a40', 
                color: 'white', 
                padding: '60px 0' 
            }}>
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <h2 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>
                                Pronto para Modernizar sua Clínica?
                            </h2>
                            <p style={{ fontSize: '1.2rem', marginBottom: '30px', opacity: 0.8 }}>
                                Junte-se a centenas de profissionais que já utilizam o MedSolutions 
                                para otimizar sua gestão médica.
                            </p>
                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                <Link to="/login">
                                    <Button 
                                        size="lg" 
                                        style={{ 
                                            backgroundColor: '#28a745', 
                                            border: 'none',
                                            padding: '15px 40px',
                                            fontSize: '1.2rem'
                                        }}
                                    >
                                        Começar Agora
                                    </Button>
                                </Link>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#25d366', 
                                        border: 'none',
                                        padding: '15px 40px',
                                        fontSize: '1.2rem'
                                    }}
                                    onClick={() => window.open('https://wa.me/5532988495161', '_blank')}
                                >
                                    <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '8px' }} />
                                    Fale Conosco
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer style={{ 
                backgroundColor: '#212529', 
                color: 'white', 
                padding: '40px 0' 
            }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <h5>MedSolutions</h5>
                            <p style={{ opacity: 0.7 }}>
                                Sistema completo de gestão médica desenvolvido pela SolutionsTI 
                                para otimizar o atendimento e administração de clínicas.
                            </p>
                        </Col>
                        <Col lg={6} className="text-lg-end">
                            <p style={{ opacity: 0.7, margin: 0 }}>
                                © 2024 SolutionsTI. Todos os direitos reservados.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    );
}